import { ReactNode } from 'react';
import { MdLockOutline } from 'react-icons/md';
import { Tab, Tabs } from '@ds';

const rulesTabTitle = (
  <div className="flex items-center gap-1">
    <MdLockOutline size={16} />
    RULES
  </div>
);

type SchedulerSettingsTabsProps = {
  inputsTab: ReactNode;
  rulesTab: ReactNode;
};

export const SchedulerSettingsTabs = ({ inputsTab, rulesTab }: SchedulerSettingsTabsProps) => {
  return (
    <Tabs
      aria-label="Tabs"
      variant="underlined"
      classNames={{
        tabContent: 'text-m-cps px-10',
        tabList: 'p-0',
        panel: 'h-full p-0',
      }}
    >
      <Tab key="inputs" title="Inputs">
        {inputsTab}
      </Tab>
      <Tab key="rules" title={rulesTabTitle}>
        {rulesTab}
      </Tab>
    </Tabs>
  );
};
